import { render } from "./PostDetailComponent.vue?vue&type=template&id=2f7cd7ac&ts=true"
import script from "./PostDetailComponent.vue?vue&type=script&lang=ts"
export * from "./PostDetailComponent.vue?vue&type=script&lang=ts"

import "./PostDetailComponent.vue?vue&type=style&index=0&id=2f7cd7ac&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__